import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: false,
    clinBitrixID: null,
    clintBitrixData: [],
    load: false,
    isAfteSendForm: false,
    isHideHead: false
  },
  mutations: {
    LOAD (state, load) {
      state.load = load;
    },

    AFTE_SEND_FORM (state) {
      state.isAfteSendForm = true;
    },

    WRITE_CLINT_DATA (state, clintBitrixData) {
      state.clintBitrixData = clintBitrixData;
      // console.info(state.clintBitrixData);

    },

    WRITE_CLINT_BITRIX_ID (state, clintID) {
      state.clinBitrixID = clintID;
      // console.log(clintID);
      // console.log(state);
    },

    ERROR (state, error) {
      state.error = error;
    },
    CHANGE_HIDE_HEAD (state) {
      state.isHideHead = true;
    }
  },
  actions: {

    CREATE_ERROR ({ commit }, error) {
      commit("ERROR", error);

    },


    SAVE_CLINT_BITRIX_ID ({ commit }, clintID) {
      commit("WRITE_CLINT_BITRIX_ID", clintID);
    },


    UPDATE_CLINT_BITRIX_DATA ({ commit }, idquery) {//получает данные клиента по айди
      const str = JSON.stringify({
        id: idquery
      });

      commit("LOAD", true);

      return (
        axios
          // .post("https://anketa.teeal.pl/dev/getName.php", str)
          .post("/dat/getName.php", str)

          .then(clintBitrixData => {

            if (clintBitrixData.data.status != "false") {
              //console.log(clintBitrixData.data.status);
              commit("WRITE_CLINT_DATA", clintBitrixData.data);
              commit("LOAD", false);
            } else {
              commit("LOAD", false);
              commit("ERROR", "не знайдено ID кліента");
            }

          })

          .catch(error => {
            commit("ERROR", error);
            console.log("error");
            console.log(error);
            commit("LOAD", false);
            return error;
          })
      );
    },
    SEARCH_BITRIX_CLINT ({ commit }, phoneClint) {
      const str = JSON.stringify({
        phone: phoneClint
      });
      commit("LOAD", true);
      return (
        axios
          // .post("https://anketa.teeal.pl/dev/bitrEnter.php", str)
          .post("/dat/bitrEnter.php", str)

          .then(clintSearchBitrix => {
            // console.log(clintSearchBitrix);
            commit("WRITE_CLINT_DATA", clintSearchBitrix.data);
            commit("LOAD", false);
            return clintSearchBitrix.data;
          })
          // .then(vakans => {
          //   commit("FILTERED_VAKANS_BY_CATEGORY", kategoryes);
          // })
          .catch(error => {
            commit("ERROR", error);
            console.log("error");
            console.log(error);
            commit("LOAD", false);
            return error;
          })
      );
    },
    CREATE_CLINT ({ commit }, dataNewClint) {
      commit("LOAD", true);
      return (
        axios
          // .post("https://anketa.teeal.pl/dev/createCont.php", dataNewClint)
          .post("/dat/createCont.php", dataNewClint)

          .then(newClint => {
            // console.log(newClint);
            commit("LOAD", false);
            // commit("WRITE_CLINT_DATA", clintSearchBitrix.data);
            return newClint.data;
          })
          // .then(vakans => {
          //   commit("FILTERED_VAKANS_BY_CATEGORY", kategoryes);
          // })
          .catch(error => {
            commit("ERROR", error);
            console.log("error");
            console.log(error);
            commit("LOAD", false);
            return error;
          })
      );

    },
    SAVE_FORM_TO_BITRIX ({ commit }, clintInputData) {
      console.log(clintInputData);

      commit("LOAD", true);
      return (
        axios
          // .post("https://anketa.teeal.pl/dev/UpdateCont.php", clintInputData)
          .post("/dat/UpdateCont.php", clintInputData)

          .then(newClint => {
            if (newClint.data.status == "ok") {
              // console.log("redyForm");
              // console.log(newClint.status);

              commit("LOAD", false);
              commit("WRITE_CLINT_BITRIX_ID", newClint.data.cont);
              commit("AFTE_SEND_FORM");
              // console.log("newClint.data");
              // console.log(newClint.data);

            }
            // commit("WRITE_CLINT_DATA", clintSearchBitrix.data);
            return newClint.data;
          })
          // .then(vakans => {
          //   commit("FILTERED_VAKANS_BY_CATEGORY", kategoryes);
          // })
          .catch(error => {
            commit("ERROR", error);
            console.log("error");
            console.log(error);
            commit("LOAD", false);
            return error;
          })
      );

    },
    HIDE_HEAD ({ commit }) {
      commit("CHANGE_HIDE_HEAD");
    }
  },
  getters: {
    GET_CLINT_BITRIX_DATA (state) {
      return state.clintBitrixData;
    },

    GET_CLINT_BITRIX_ID (state) {
      return state.clinBitrixID;
    },
    GET_ERROR (state) {
      return state.error;
    },
    GET_LOAD (state) {
      return state.load;
    },
    GET_AFTE_SEND_FORM (state) {
      return state.isAfteSendForm;
    },
    GET_HIDE_HEAD (state) {
      return state.isHideHead;
    }
  }
});
